import { BoxProps, Flex } from '@chakra-ui/react';
import React from 'react';
import Statistics from 'style/statistics.module.css';

interface CardProps extends BoxProps {
  title?: string;
  percentage: number;
  fontSize?: number;
  facility: number;
  useManualPriceFactor: boolean;
}

export function PriceFactorCard({
  title,
  percentage,
  fontSize,
  facility,
  useManualPriceFactor,
  ...rest // only BoxProps go here
}: CardProps): JSX.Element {
  return (
    <Flex
      className={Statistics.card}
      {...rest} // ✅ only spread BoxProps
      data-facility-id={facility}
      flex="1"
      flexDir="column"
      justify="center"
      align="center"
      minH="235px">
      {title && <span className={Statistics.cardTitle}>{title}</span>}
      <span
        style={{ fontSize: fontSize || 42 }}
        className={Statistics.cardNumber}>
        {percentage}%
      </span>
      <span style={{ fontSize: 12 }}>
        {useManualPriceFactor ? 'Manuell prisfaktor' : 'Automatisk prisfaktor'}
      </span>
    </Flex>
  );
}
